import { render, staticRenderFns } from "./doctorType.vue?vue&type=template&id=429c8c26&scoped=true&"
import script from "./doctorType.vue?vue&type=script&lang=js&"
export * from "./doctorType.vue?vue&type=script&lang=js&"
import style0 from "./doctorType.vue?vue&type=style&index=0&id=429c8c26&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429c8c26",
  null
  
)

export default component.exports